import PropTypes from 'prop-types';

import { useRef, useState, useEffect } from 'react';

import { Box, Button, styled } from '@mui/joy';

import { InputField } from './InputField'

import { Img } from './Img'

import i18n from '@/i18n'

export const ImageFrame = styled(
  Box,
  {
    slot: 'root',
    name: "ImageFrame"
  }
)(({ theme }) => ({
  'img': {
    padding: 0,
    margin: 0,
    borderWidth: theme.variants.outlined.borderWidth,
    alignSelf: 'flex-start',
    aspectRatio: '1/1',
    borderColor: theme.variants.outlined.neutral.borderColor,
    borderStyle: 'solid',
  }
}))

export function ImageEditor({ 
  imageUrl,
  readOnly,
  accept=".png,.jpg,.jpeg",
  onChange = () => console.warn('On change not implemented'),
  onChangeURL = () => console.warn('onChangeURL not implemented')
}) {
  const [file, setFile] = useState(null)
  const fileInputRef = useRef(null)
  const handleBrowseClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }
  const handleFileInputChange = (event) => {
    const file = event.target.files[0]
    onChange(file)
  }

  const handleRemoveClick = () => {
    onChange(null)
  }
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 2 }}>
      <ImageFrame>
        <Img src={imageUrl} style={{ objectFit: 'contain', aspectRatio: '1/1', margin: 0, padding: 0, width: '120pt' }} />
      </ImageFrame>
      <Button aria-label="Browse" disabled={readOnly} variant="outlined" onClick={handleBrowseClick}>{i18n.t('browse')}</Button>
      <Button aria-label="Remove" disabled={readOnly} variant="outlined" onClick={handleRemoveClick}>{i18n.t('remove')}</Button>
      <input type="file" accept={accept} onChange={handleFileInputChange} ref={fileInputRef} style={{ display: 'none' }} />
    </Box>
  )
}

ImageEditor.propTypes = {
  imageUrl: PropTypes.string,
  readOnly: PropTypes.bool,
  accept: PropTypes.string,
  onChange: PropTypes.func,
  onChangeURL: PropTypes.func
}


export function ArtworkField({
  imageUrl,
  label,
  defaultValue,
  errors,
  info,
  onChange,
  readOnly,
  accept,
  onChangeURL
}) {
  return (
    <InputField
      errors={errors}
      info={info}
      label={label}
    >
      <ImageEditor accept={accept} readOnly={readOnly} defaultValue={defaultValue} onChangeURL={onChangeURL} imageUrl={imageUrl} onChange={onChange} />
    </InputField>
  )
}

ArtworkField.propTypes = {
  imageUrl: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  errors: PropTypes.object,
  info: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  accept: PropTypes.string,
  onChangeURL: PropTypes.func
}

ArtworkField.defaultProps = {
  onChange: () => {},
  onChangeURL: () => {},
  readOnly: false,
  accept: '.png,.jpg,.jpeg'
}
